export default "__VITE_PUBLIC_ASSET__b50e54c9__"